import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'

import { MESSAGE, UI } from '../config'
import BrowseGuideLayout from '../components/BrowseGuideLayout'
import ContentList from '../components/ContentList'
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined'

const PrintableOwnersManual = ({ baseRoute, match, ownersManualPdfs }) => {
  const topics =
    ownersManualPdfs && ownersManualPdfs.size
      ? ownersManualPdfs
          .map(item => ({
            id: item.get('id'),
            title: item.get('title') || UI.OWNERS_MANUAL_PDF_TITLE[item.get('locale')],
            downloadUrl: item.getIn(['bodyPdf', 'url']),
            language: item.get('language'),
            isPdfDownload: true,
            icon: (
              <div className="icon icon-list-pdf">
                <PictureAsPdfOutlinedIcon />
              </div>
            ),
          }))
          .toJS()
      : []

  return (
    <BrowseGuideLayout match={match} baseRoute={baseRoute}>
      <ContentList variant='browse-guide' topics={topics} emptyText={MESSAGE.EMPTY_TOPICS} />
    </BrowseGuideLayout>
  )
}

PrintableOwnersManual.propTypes = {
  baseRoute: PropTypes.string.isRequired,
  match: PropTypes.object.isRequired,
  ownersManualPdfs: ImmutablePropTypes.list,
}

export default PrintableOwnersManual
